<template>
    <div>
        <el-alert title="温馨提示: 点击表格行首的 “箭头” 展开可以查看更多信息和进行相应操作" type="success" close-text="朕知道了"></el-alert>
        <el-table v-loading="showLoading" :data="tasks" :default-expand-all="false" style="width: 100%">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="任务主题">
                            <span>{{ props.row.subject }}</span>
                        </el-form-item>
                        <el-form-item label="类型">
                            <span>{{ props.row.type_memo }}</span>
                        </el-form-item>
                        <el-form-item label="创建人">
                            <span>{{ props.row.creator_name }}</span>
                        </el-form-item>
                        <el-form-item label="客户">
                            <span>{{ props.row.customer_name }}</span>
                        </el-form-item>
                        <el-form-item label="任务执行人">
                            <span>{{ props.row.executor_name }}</span>
                        </el-form-item>
                        <el-form-item label="任务来源">
                            <span>{{ props.row.origin_memo }}</span>
                        </el-form-item>
                        <el-form-item label="状态">
                            <span> {{props.row.status_memo}} </span>
                        </el-form-item>
                        <el-form-item label="备注">
                            <span> {{props.row.memo}} </span>
                        </el-form-item>
                        <el-form-item v-if="props.row.status == 4" label="未完成原因">
                            <span> {{props.row.reason}} </span>
                        </el-form-item>
                        <el-form-item label="创建时间">
                            <span> {{props.row.created_at}} </span>
                        </el-form-item>
                        <el-form-item label="更新时间">
                            <span> {{props.row.updated_at}} </span>
                        </el-form-item>
                        <el-row>
                            <el-form-item v-if="tab=='MyTask'">
                                <el-button @click="handleCancel(props.row)" size="small" plain>取消</el-button>
                                <el-button @click="handleDelete(props.row)" type="danger" size="small" plain>删除
                                </el-button>
                                <el-button v-if="props.row.status == 0" @click="handleDone(props.row)" type="success"
                                           size="small" plain>完成
                                </el-button>
                            </el-form-item>
                            <el-form-item v-if="tab=='MyCreated'">
                                <el-button @click="handleDelete" type="danger" size="small" plain>删除</el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="customer_name" label="客户名称"></el-table-column>
            <el-table-column prop="type_memo" label="任务类型"></el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <i v-if="scope.row.status == 1" style="color: #67C23A;" class="el-icon-circle-check"></i>
                    <i v-else-if="scope.row.status == 0" style="color: #409EFF" class="el-icon-time"></i>
                    <i v-else style="color: #F56C6C;" class="el-icon-circle-close"></i>
                    <span>{{ scope.row.status_memo }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间"></el-table-column>
            <el-table-column prop="updated_at" label="最后更新时间"></el-table-column>
        </el-table>

        <!--跟进组件-->
        <trace-modal
                :show-dialog="showTraceModal"
                :customer-id="currentTask.customer_id"
                :enableCallback="true"
                @closeModal="closeModal"
                @traceCallBack="handleCallBack"
                :is-finished="isFinished"
        >
        </trace-modal>

        <!-- 回访组件 -->
        <visit-modal
                :show-dialog="showAccessModal"
                :customer-id="currentTask.customer_id"
                :enableCallback="true"
                @closeModal="closeModal"
                @traceCallBack="handleCallBack"
                :is-finished="isFinished"
        >
        </visit-modal>

    </div>

</template>

<style>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>

<script>
    import TraceModal from "./TraceModal.vue";
    import VisitModal from "./VisitModal.vue";
    import TaskService from "~/services/task";
    import {
        TYPE_TRACE,
        TYPE_AUDIT,
        TYPE_CHECK,
        TYPE_CALLBACK,
        STATUS_ONGOING, //进行中
        STATUS_FINISHED, // 已完成
        STATUS_CANCEL, // 已取消
        STATUS_DELETED, // 已删除
        STATUS_UNFINISHED // 未完成状态
    } from "~/services/task";

    export default {
        name: "TaskList",
        components: {
            VisitModal,
            TraceModal
        },
        props: {
            tasks: {
                type: Array,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            tabName: ""
        },
        data: function () {
            return {
                showLoading: false,
                expandAll: true, // 展开
                tab: "",
                showTraceModal: false,
                showAccessModal: false,
                currentTask: {}, // 当前被选择操作的任务数据
                isFinished: false
            };
        },
        created: function () {
            this.tab = this.tabName;
        },
        watch: {
            tabName: function (value, original) {
                this.tab = value;
            },

            loading: function (value, original) {
                this.showLoading = value;
            }

        },
        methods: {

            handleDelete(task) {

                if (!task) {
                    return;
                }

                this.$confirm("确定要删除该任务?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    TaskService.delete(task.id).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                type: "success",
                                message: "删除成功!"
                            });
                            this.reloadList();
                        }
                    }).catch(err => {
                        console.error(err);
                    });

                })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },

            handleCancel(task) {
                if (!task) {
                    return;
                }
                this.$confirm("确定要取消执行该任务?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    TaskService.cancel(task.id)
                        .then(res => {
                            if (res && res.code == 0) {
                                this.$message({
                                    type: "success",
                                    message: "执行成功!"
                                });

                                this.reloadList();
                            }
                        })
                        .catch(err => {
                            console.log("cancel");
                        });
                })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消执行"
                        });
                    });
            },

            // 监听对话框关闭事件
            closeModal(isShow) {
                this.showTraceModal = isShow;
                this.showAccessModal = isShow;
                this.isFinished = isShow;
            },

            // 处理完成任务
            handleDone(row) {
                // 只有正在进心中的任务才可以执行完成操作
                if (!row || row.status !== STATUS_ONGOING) {
                    return;
                }

                switch (row.type) {
                    case TYPE_TRACE:
                        this.handleTrace(row);
                        break;
                    case TYPE_CALLBACK:
                        this.handleAccess(row);
                        break;
                    case TYPE_AUDIT:
                        this.handleAudit(row);
                        break;
                    case TYPE_CHECK:
                        this.handleCheck(row);
                        break;
                }
            },

            // 处理完成跟进任务
            handleTrace(row) {
                this.showTraceModal = true;
                this.currentTask = row;
            },

            // 回调TraceModal组件中填写的数据然后处理提交
            handleCallBack(data) {
                TaskService.done({
                    task_id: this.currentTask.id,
                    type: this.currentTask.type,
                    params: data
                }).then(res => {
                    if (res && res.code == 0) {
                        this.isFinished = true;
                        this.$message({
                            type: "success",
                            message: "操作成功!"
                        });

                        // 强制刷新任务列表数据
                        this.reloadList();
                    }
                }).catch(err => {
                    console.error(err);
                });
            },

            // 处理完成回访任务
            handleAccess(row) {
                this.showAccessModal = true;
                this.currentTask = row;
            },

            // 处理完成审核任务
            handleAudit(row) {
            },

            // 处理完成核对任务
            handleCheck(row) {
            },

            // 重新加载列表数据
            reloadList() {
                // 强制刷新任务列表数据
                this.$emit("refreshTasks", {executor_id: this.$store.getters.userId});
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/tasks/list.vue